export const SERVICE_REQ_CAT_IMAGES = "SERVICE_REQ_CAT_IMAGES";
export const SERVICE_REQ_CAT_IMAGE = "SERVICE_REQ_CAT_IMAGE";
export const MTT_CAT_IMAGES = "MTT_CAT_IMAGES";
export const MTT_SELECTED_CAT = "MTT_SELECTED_CAT";
export const MTT_NAVIGATION = "MTT_NAVIGATION";
export const ORQST_REFRESH_CAT_IMAGES = "ORQST_REFRESH_CAT_IMAGES";
export const ORQST_REFRESH_SELECTED_CAT = "ORQST_REFRESH_SELECTED_CAT";
export const GET_CAT_IMAGES = "GET_CAT_IMAGES";
export const GET_VISIBLE_CAT_IMAGE = "GET_VISIBLE_CAT_IMAGE";
export const GET_SELECTED_CAT = "GET_SELECTED_CAT";
export const GET_NAVIGATION = "GET_NAVIGATION";
export const ACTION_NEXT_PAGE = "ACTION_NEXT_PAGE";
export const ACTION_PREV_PAGE = "ACTION_PREV_PAGE";
